export default "/_next/static/images/modal2-305c096137b8f44d9b711331dbc442f9.png";